import {
  Component,
  OnInit,
  ViewChild,
  ViewChildren,
  QueryList,
  ViewEncapsulation,
  AfterViewChecked,
  AfterViewInit,
  OnDestroy,
  NgZone
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MatExpansionPanel } from '@angular/material/expansion';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { CaseDataService } from '@app/core/services/case-data/case-data.service';
import { CedenteService } from '@app/core/services/cedente/cedente.service';
import { MenuService } from '@app/core/services/menu/menu.service';
import { NavMenuService } from '@app/core/services/nav-menu/nav-menu.service';
import { DOCTOR } from '../utils/commonMethods';

@Component({
  selector: 'app-maresel-nav-menu',
  templateUrl: './maresel-nav-menu.component.html',
  styleUrls: ['./maresel-nav-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MareselNavMenuComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  @ViewChild('drawer') public sidenav: MatSidenav;
  @ViewChildren(MatExpansionPanel) panels: QueryList<MatExpansionPanel>;

  activeLink: any;
  activeLink2: any;
  activeLink3: any;

  currentLink: string;
  allMenuIndex: any;
  displayedLevel2: any;

  currentUrl: string;
  content: string;
  routeBase: string;

  private contentLoadedObserver: MutationObserver;
  private scrollCheckInterval: any;
  private lastScrollTop = 0;
  private preventScrollToActive = false;
  private userInteracted = false;
  private scrollAttempts = 0;
  private userInteractionListenersActive = false;

  constructor(
    public menuService: MenuService,
    public navMenuService: NavMenuService,
    public caseDataSrv: CaseDataService,
    private cedenteSrv: CedenteService,
    private router: Router,
    private authSrv: AuthenticationService,
    private route: ActivatedRoute,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    // Escuchar eventos de navegación para actualizar los parámetros
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.getRouteParams();

      // Solo aplicar la lógica de prevención de scroll en páginas con menú vertical (risks)
      if (this.routeBase === 'risks') {
        // Activar la prevención de scroll al navegar
        this.preventScrollToActive = true;
        this.userInteracted = false;
        this.scrollAttempts = 0;
        this.userInteractionListenersActive = false;
        this.forceScrollToTop();
        this.startScrollMonitoring();
        // Retrasar activación de listeners de usuario 800ms para evitar eventos automáticos
        setTimeout(() => {
          if (this.preventScrollToActive) {
            this.setupUserInteractionListeners();
          }
        }, 800);
      }
    });

    // Obtener parámetros de la ruta actual al inicializar
    this.getRouteParams();

    if (this.menuService.menuResponse?.length === 0) {
      this.menuService.getMenu();
    }
    this.caseDataSrv.checkCase();
    this.cedenteSrv.getCedentes();
    this.currentLink = this.menuService.getCurrentMenu();

    // Configurar listeners de interacción del usuario después de un delay solo para páginas de risks
    if (this.routeBase === 'risks') {
      setTimeout(() => {
        this.setupUserInteractionListeners();
      }, 800);
    }
  }

  getRouteParams() {
    // Obtener la ruta activa navegando por el árbol de rutas
    let route = this.route;
    while (route.firstChild) {
      route = route.firstChild;
    }

    // Obtener riesgo
    this.content = route.snapshot.params['content'];

    // Obtener la ruta base desde la URL actual
    this.currentUrl = this.router.url;
    const pathSegments = this.currentUrl.split('/').filter((segment) => segment && !segment.includes('?'));
    this.routeBase = pathSegments[0];
  }

  ngAfterViewInit(): void {
    // Configurar el observer para detectar cambios en el contenido solo en páginas de risks
    if (this.routeBase === 'risks') {
      this.setupContentObserver();
    }
    // Configurar el sidenav en el servicio
    this.navMenuService.setSidenav(this.sidenav);

    this.menuService.getMenuLabels().subscribe(() => {
      this.allMenuIndex = this.menuService?.menuResponse;
      this.menuService.setTitleMenu(this.currentUrl);
      this.checkMenu();
    });
  }

  ngAfterViewChecked(): void {
    // Forzar scroll al top solo si está activado Y el usuario no ha interactuados solo en paginas de risks
    if (this.routeBase === 'risks') {
      if (this.preventScrollToActive && !this.userInteracted) {
        this.forceScrollToTop();
      }
    }
  }

  ngOnDestroy(): void {
    // Limpiar el observer y el interval
    if (this.contentLoadedObserver) {
      this.contentLoadedObserver.disconnect();
    }
    if (this.scrollCheckInterval) {
      clearInterval(this.scrollCheckInterval);
    }
  }

  checkMenu() {
    let i = 0;
    this.navMenuService.secondLevelBoolean = false; // Establece inicialmente a false

    for (const item of this.allMenuIndex) {
      if (i < 3) {
        // Convertir el array menu a string y verificar si contiene routeBase
        const menuString = JSON.stringify(item.menu);
        if (menuString.includes(this.routeBase)) {
          this.navMenuService.secondLevelBoolean = true; // Si encuentra una coincidencia, establece a true
          // simular el click
          this.navMenuService.hoverL1(item);
          if (this.content) {
            // Buscamos el riesgo
            let riskFound = false;
            for (const risk of item.menu) {
              if (risk.menu && Array.isArray(risk.menu)) {
                let index = 0;
                for (const riskType of risk.menu) {
                  if (riskType.menu && Array.isArray(riskType.menu)) {
                    for (const riskElement of riskType.menu) {
                      const content = riskElement.content.split('/').pop();
                      if (content === this.content) {
                        riskFound = true;
                        this.navMenuService.hoverL2(risk);
                        this.activeLink2 = riskElement.content;
                        setTimeout(() => {
                          this.openPanelByIndex(index);
                        }, 1000);
                        break;
                      }
                    }
                    if (riskFound) {
                      break;
                    }
                    index++;
                  } else {
                    const content = riskType.content.split('/').pop();
                    if (content === this.content) {
                      riskFound = true;
                      this.navMenuService.hoverL2(risk);
                      this.activeLink2 = riskType.content;
                    }
                  }
                }
              }
              if (riskFound) {
                break;
              }
            }
          }
          break; // Detén la ejecución del bucle una vez que se encuentra una coincidencia
        }
        i++;
      } else {
        break; // Si ya se han verificado las tres primeras entradas, detén la ejecución del bucle
      }
    }
  }

  hoverL1(link: any) {
    this.activeLink = null;
    this.navMenuService.hoverL1(link);
  }

  hoverL2(link: any) {
    this.activeLink2 = null;
    this.navMenuService.hoverL2(link);
  }

  hoverL3(link: any) {
    this.activeLink3 = null;
    this.navMenuService.hoverL3(link);
  }

  childresIsActive(link: any) {
    for (let index = 0; index < link?.length; index++) {
      const element = link[index];
      if (element.content === this.router.url) {
        return true;
      } else {
        const result = this.childresIsActive(element.menu);
        if (result) {
          return true;
        }
      }
    }
  }

  isDoctorRole() {
    return this.authSrv.checkRolUser(DOCTOR);
  }

  // Abrir un panel específico por índice
  openPanelByIndex(index: number) {
    const panelsArray = this.panels?.toArray();
    if (panelsArray && panelsArray[index]) {
      panelsArray[index].open();
    }
  }

  // Cerrar un panel específico por índice
  closePanelByIndex(index: number) {
    const panelsArray = this.panels?.toArray();
    if (panelsArray && panelsArray[index]) {
      panelsArray[index].close();
    }
  }

  // Toggle de un panel específico por índice
  togglePanelByIndex(index: number) {
    const panelsArray = this.panels?.toArray();
    if (panelsArray && panelsArray[index]) {
      panelsArray[index].toggle();
    }
  }

  private setupContentObserver(): void {
    // Observar cambios en el contenido para detectar cuando se carga
    const targetNode = document.querySelector('mat-drawer-content') || document.body;

    const config = {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true
    };

    this.contentLoadedObserver = new MutationObserver((mutations) => {
      // Cuando el contenido cambia, activar la prevención de scroll
      if (this.preventScrollToActive) {
        this.ngZone.runOutsideAngular(() => {
          setTimeout(() => {
            this.forceScrollToTop();
          }, 0);
        });
      }
    });

    if (targetNode) {
      this.contentLoadedObserver.observe(targetNode, config);
    }
  }

  private startScrollMonitoring(): void {
    // Limpiar intervalo anterior si existe
    if (this.scrollCheckInterval) {
      clearInterval(this.scrollCheckInterval);
    }

    // Monitorear el scroll durante 4 segundos después de la navegación
    let checkCount = 0;
    const maxChecks = 40; // 4 segundos (40 * 100ms)
    let stableScrollCount = 0;

    this.scrollCheckInterval = setInterval(() => {
      checkCount++;

      // Si el usuario ha interactuado, detener inmediatamente
      if (this.userInteracted) {
        clearInterval(this.scrollCheckInterval);
        this.preventScrollToActive = false;
        return;
      }

      const currentScrollTop = this.getScrollTop();

      // Si el scroll ha cambiado y no está en el top, forzar al top SOLO si no es por interacción del usuario
      if (currentScrollTop > 0 && this.preventScrollToActive && !this.userInteracted) {
        this.scrollAttempts++;
        this.forceScrollToTop();
        stableScrollCount = 0; // Resetear contador de estabilidad

        // Si hemos intentado muchas veces y el scroll sigue moviéndose hacia arriba agresivamente
        // probablemente sea el usuario intentando hacer scroll
        if (this.scrollAttempts > 8 && currentScrollTop > this.lastScrollTop + 10 && this.userInteractionListenersActive) {
          this.userInteracted = true;
          this.preventScrollToActive = false;
          clearInterval(this.scrollCheckInterval);
          return;
        }
      } else if (currentScrollTop === 0) {
        stableScrollCount++;
      }

      // Detener el monitoreo después del tiempo máximo o si el scroll se mantiene en 0 por suficiente tiempo
      if (checkCount >= maxChecks || stableScrollCount > 15) {
        clearInterval(this.scrollCheckInterval);
        this.preventScrollToActive = false;
      }

      this.lastScrollTop = currentScrollTop;
    }, 100);
  }

  private setupUserInteractionListeners(): void {
    // Si ya están activos, no duplicar
    if (this.userInteractionListenersActive) {
      return;
    }

    this.userInteractionListenersActive = true;

    // Lista de eventos que indican que el usuario está intentando hacer scroll
    const userEvents = ['wheel', 'touchstart', 'touchmove', 'keydown'];

    const handleUserInteraction = (event: any) => {
      // Si es un evento de teclado, verificar que sea una tecla de navegación
      if (event.type === 'keydown') {
        const navigationKeys = ['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Space', 'Home', 'End'];
        if (!navigationKeys.includes(event.key)) {
          return;
        }
      }

      // Verificar que el evento tenga movimiento real (no eventos automáticos)
      if (event.type === 'wheel' && Math.abs(event.deltaY) < 5) {
        return; // Ignorar movimientos muy pequeños que podrían ser automáticos
      }

      // El usuario está interactuando, desactivar la prevención
      this.userInteracted = true;
      this.preventScrollToActive = false;
      this.userInteractionListenersActive = false;

      // Remover los listeners ya que ya no son necesarios
      userEvents.forEach((eventName) => {
        document.removeEventListener(eventName, handleUserInteraction, { capture: true } as any);
      });
    };

    // Agregar listeners para detectar interacción del usuario
    userEvents.forEach((eventName) => {
      document.addEventListener(eventName, handleUserInteraction, { passive: true, capture: true });
    });

    // Auto-remover después de 5 segundos para no dejar listeners huérfanos
    setTimeout(() => {
      if (this.userInteractionListenersActive) {
        userEvents.forEach((eventName) => {
          document.removeEventListener(eventName, handleUserInteraction, { capture: true } as any);
        });
        this.userInteractionListenersActive = false;
      }
    }, 5000);
  }

  private getScrollTop(): number {
    // Obtener la posición actual del scroll de múltiples fuentes
    const ionContent = document.querySelector('ion-content');
    if (ionContent) {
      const scrollElement = ionContent.shadowRoot?.querySelector('.inner-scroll');
      if (scrollElement) {
        return scrollElement.scrollTop;
      }
    }

    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  private forceScrollToTop(): void {
    // No forzar si el usuario ya interactuó
    if (this.userInteracted) {
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      // Método 1: ion-content (Ionic) - prioridad para Ionic
      const ionContent = document.querySelector('ion-content');
      if (ionContent && typeof ionContent.scrollToTop === 'function') {
        ionContent.scrollToTop(0);
      }

      // Método 2: window.scrollTo
      if (window) {
        window.scrollTo(0, 0);
      }

      // Método 3: document.documentElement
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }

      // Método 4: document.body
      if (document.body) {
        document.body.scrollTop = 0;
      }

      // Método 5: Prevenir scroll en elementos activos del menú
      // Hacerlo en cada intento, no solo la primera vez
      const activeElements = document.querySelectorAll(
        '.active-lits-item, a[mat-list-item].mat-list-item-focus, .mat-list-item-focus, mat-list-item[aria-current="true"]'
      );
      activeElements.forEach((el: any) => {
        if (el.scrollIntoView) {
          const originalScrollIntoView = el.scrollIntoView;
          el.scrollIntoView = () => {};
          // Guardar el original para no perderlo
          if (!el._originalScrollIntoView) {
            el._originalScrollIntoView = originalScrollIntoView;
          }
        }
      });

      // Restaurar scrollIntoView después de que termine la prevención
      if (this.scrollAttempts === 0) {
        setTimeout(() => {
          activeElements.forEach((el: any) => {
            if (el._originalScrollIntoView) {
              el.scrollIntoView = el._originalScrollIntoView;
              delete el._originalScrollIntoView;
            }
          });
        }, 4500);
      }
    });
  }
}
